import { ROOT_CATALOG_URL } from '@/shared/constants/urlConstants';

import {
  SEARCH_HINT_LABEL_CITY,
  SEARCH_HINT_LABEL_METRO,
  SEARCH_HINT_LABEL_NAME,
  SEARCH_HINT_LABEL_ORGANIZATION,
  SEARCH_HINT_LABEL_SERVICE,
  SEARCH_HINT_LABEL_SPECIALIZATION,
  SEARCH_HINT_LABEL_SUGGESTIONS,
} from '@/shared/constants/searchHintsConstants';

import useSearchHints from '@/shared/composables/useSearchHints';

const useGlobalSearch = () => {
  const route = useRoute();
  const router = useRouter();

  const { searchValue, itemsList, isShowHint, searchHandler, showHints, onHide } =
    useSearchHints({
      labels: {
        subcategory: SEARCH_HINT_LABEL_SERVICE,
        category: SEARCH_HINT_LABEL_SPECIALIZATION,
        metro: SEARCH_HINT_LABEL_METRO,
        city: SEARCH_HINT_LABEL_CITY,
        lawyer: SEARCH_HINT_LABEL_NAME,
        hints: SEARCH_HINT_LABEL_SUGGESTIONS,
        company: SEARCH_HINT_LABEL_ORGANIZATION,
      },
      initialValue: route.query?.q ? String(route.query.q) : '',
    });

  const isShowSearchInput: Ref<boolean> = ref(false);
  const isActiveInputIcon: Ref<boolean> = ref(false);

  const isHasSearchQuery: ComputedRef<boolean> = computed(() => Boolean(route.query?.q));

  const showHintsWithIcon = (): void => {
    showHints();
    isActiveInputIcon.value = true;
  };

  const blurHandler = (): void => {
    isActiveInputIcon.value = false;
  };

  const submitHandler = (): void => {
    if (searchValue.value) {
      router.push({
        path: ROOT_CATALOG_URL,
        query: { q: searchValue.value },
      });
    } else {
      router.push({ path: ROOT_CATALOG_URL });
    }
  };

  const clearInput = (): void => {
    searchValue.value = '';
    const query = { ...route.query };
    delete query.q;
    router.push({ path: route.path, query });
  };

  watch(
    () => route.query?.q,
    (q) => {
      searchValue.value = q ? String(q) : '';
    },
  );

  return {
    isShowHint,
    isShowSearchInput,
    searchValue,
    itemsList,
    isActiveInputIcon,
    isHasSearchQuery,
    onHide,
    showHints: showHintsWithIcon,
    searchHandler,
    submitHandler,
    blurHandler,
    clearInput,
  };
};

export default useGlobalSearch;
